import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Alert, Button, Form, Input } from 'antd';
import { AppContext } from '../../app';
import {
  buildOrbitCallBody,
  findOrbitMissionEventOccurrence,
  getOrbitCallHeaders,
  getOrbitTrackerUrl,
  ORBIT_CALL_UI_KEY,
  ORBIT_MISSION_START_EVENT_NAME,
  parseOrbitCallOsi,
} from '../../utils/hooks';

const AcOrbitCall = (props) => {
  const { journey, syncCache, eventsContext } = useContext(AppContext);
  const [form] = Form.useForm();
  const [osi, setOsi] = useState('');

  const currentStep = journey.steps.find(
    (step) => step.id + '' === props.node.id + ''
  );

  const isActionStep = props.node?.data?.nodeType === 'ACTION';
  const isViewModeWithRunningPaused =
    props.readOnly &&
    (journey?.status === 'RUNNING' || journey?.status === 'PAUSED');
  const effectiveReadOnly =
    isActionStep && isViewModeWithRunningPaused
      ? false
      : props.readOnly || props.mode === 'report';

  const orbitEventStep = useMemo(
    () => findOrbitMissionEventOccurrence(journey?.steps, eventsContext),
    [journey?.steps, eventsContext]
  );

  useEffect(() => {
    const existingOsi = parseOrbitCallOsi(currentStep?.body);
    setOsi(existingOsi);
    form.setFieldsValue({ osi: existingOsi });
  }, []);

  const onFinish = async (values) => {
    if (!currentStep || effectiveReadOnly) return;
    if (!orbitEventStep) {
      return;
    }

    const osiValue = (values.osi || '').trim();
    // Always re-resolve the current orbit EVENT_OCCURRENCE so omti templates stay fresh
    const resolvedOrbitEventStep = findOrbitMissionEventOccurrence(
      journey?.steps,
      eventsContext
    );
    if (!resolvedOrbitEventStep) {
      return;
    }

    const updatedStep = Object.assign({}, currentStep, {
      type: 'CALL_API',
      method: 'POST',
      url: getOrbitTrackerUrl(),
      headers: getOrbitCallHeaders(),
      body: buildOrbitCallBody(osiValue, resolvedOrbitEventStep.id),
      ui: Object.assign({}, currentStep.ui, {
        key: ORBIT_CALL_UI_KEY,
      }),
    });
    delete updatedStep.ui?.error;

    syncCache('update-step', updatedStep, true);
    props.closeModal();
  };

  return (
    <>
      <div className="modal-body">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ osi }}
        >
          {!orbitEventStep && (
            <Alert
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
              message={`Add an Occurrence of Event step for ${ORBIT_MISSION_START_EVENT_NAME} before configuring Orbit Call.`}
            />
          )}

          <Form.Item
            label="OSI"
            name="osi"
            rules={[
              { required: true, message: 'Please enter OSI' },
              {
                whitespace: true,
                message: 'Please enter OSI',
              },
            ]}
          >
            <Input
              placeholder="Enter OSI"
              disabled={effectiveReadOnly || !orbitEventStep}
              onChange={(e) => setOsi(e.target.value)}
            />
          </Form.Item>

          <div className="modal-footer">
            <Form.Item>
              <Button
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={effectiveReadOnly || !orbitEventStep}
              >
                SAVE
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AcOrbitCall;
